<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form
      :model="formData"
      ref="detailInfo"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card" v-model="selectLang">
        <el-tab-pane
          :name="item.name"
          :label="$t('message.' + item.name)"
          v-for="(item, index) in langList"
          :key="index"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label"> Title </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="item.titleName"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      v-model="formData[item.titleName]"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> E-Learning </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="elearningId"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-select v-model="formData.elearningId">
                      <el-option
                        v-for="item in elearningList"
                        :key="item.elearningId"
                        :label="item.title"
                        :value="item.elearningId"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button @click="handleSubmit" type="primary"
                      >Save</el-button
                    >
                    <el-button @click="handleBack">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import axios from "axios";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      id: "",
      formData: {
        titleEn: "",
        titleSc: "",
        titleTc: "",
        elearningId: "",
      },
      selectLang: "en_US",
      elearningList:[]
    };
  },
  computed: {
    langList() {
      return [
        { name: "en_US", titleName: "titleEn" },
        { name: "zh_CN", titleName: "titleSc" },
        { name: "zh_HK", titleName: "titleTc" },
      ];
    },
    baseURL() {
      return config.domain + "/";
    },
    userInfo() {
      return this.getAuthObj();
    },
  },

  async created() {
    this.id = this.$route.query.id;
    if (this.id) await this.intiPage();
    await this.getElearningList()
  },
  mounted() {},
  methods: {
    async intiPage() {
      const param = {
        ...this.userInfo,
        id: this.id,
      };
      const {
        data: { result, status_code, status_message },
      } = await axios.post(this.baseURL + "websiteElearningMenu/detail", param);
      if (status_code == "0") {
        this.formData = result;
      } else {
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    async getElearningList(){
         const param = {
        ...this.userInfo,
        title:'',
        id:this.formData.elearningId,
        pageSize:10,
        pageIndex:1,
        sortType:"",
        sortName:""
      };
      const {
        data: { result, status_code, status_message },
      } = await axios.post(this.baseURL + "websiteElearningMenu/getElearningList", param);
      if (status_code == "0") {
        this.elearningList = result.elearningList;
      } else {
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    async handleSubmit() {
      this.$refs["detailInfo"].validate(async (valid) => {
        if (valid) {
          const param = {
            ...this.formData,
            ...this.userInfo,
          };
          if (this.id) param.id = this.id;
          const {
            data: { status_code, status_message },
          } = await axios.post(
            this.baseURL +
              (this.id
                ? "websiteElearningMenu/update"
                : "websiteElearningMenu/create"),
            param
          );
          if (status_code == "0") {
          } else {
            this.$store.getters.warning.warningMsg = status_message;
            this.$store.getters.warning.warningFalg = true;
          }
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    handleBack() {
      this.$router.go(-1);
    },
  },
};
</script>
